exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-content[data-v-74695184]{position:relative;overflow:visible;padding:1.25rem}.tabs-content .mobile-only[data-v-74695184]{display:none}@media screen and (max-width:650px){.tabs-content[data-v-74695184]{position:fixed;top:150%;bottom:-150%;left:0;right:0;z-index:-1}.tabs-content .mobile-only[data-v-74695184]{display:block}.tabs-content.opened[data-v-74695184]{top:0;bottom:0;z-index:999999;background:rgba(0,0,0,.5)}.tabs-content.opened .tabs-content__inner[data-v-74695184]{position:absolute;top:0;left:0;right:0;bottom:0;overflow-y:auto;display:block;padding:20px 20px 80px;background:#fff}.tabs-content.opened .tabs-content__footer[data-v-74695184]{position:absolute;bottom:0;right:0;left:0;display:block;padding:20px;background:#eee;border-top:1px solid #ddd}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74695184","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Tabs/Content.vue
// module id = ZDNW
// module chunks = 115 116